import Axios, { isAxiosError } from "axios";
import { isProblemDetails } from "ls/api/common/server";
import { serverApiUrl } from "ls/api/urls";

export const server = Axios.create({
  baseURL: serverApiUrl,
  withCredentials: import.meta.env.DEV,
  withXSRFToken: true,
});

let acquiredXsrfToken = false;
server.interceptors.request.use(async request => {
  if (request.withXSRFToken && !acquiredXsrfToken && request.data instanceof FormData) {
    await server.get("antiforgery/token");
    acquiredXsrfToken = true;
  }
  return request;
});

server.interceptors.response.use(undefined, error => {
  if (isAxiosError(error)) {
    if (error.response && isProblemDetails(error.response.data)) {
      const problem = error.response.data;
      if (problem.exception?.details) {
        console.error(problem.exception.details);
      }
      const message = problem.detail ?? problem.title;
      throw new Error(message);
    }
  }
  return Promise.reject(error);
});
